exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardTotal-140c3{width:32%}", ""]);

// Exports
exports.locals = {
	"dashboardTotal": "dashboardTotal-140c3"
};